import React from "react";
import {Route, Switch, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import Dashboard from "./containers/Dashboard";
import Clients from "./containers/Clients";
import AddClient from "./containers/AddClient";
import UpdateClient from "./containers/UpdateClient";
import Login from "./containers/Login";
import Logout from "./containers/Logout";
import NotFound from "./containers/NotFound";
import AdminDashboard from "./containers/AdminDashboard";
import Resellers from "./containers/Resellers";
import AddReseller from "./containers/AddReseller";
import AdminResellers from "./containers/AdminResellers";
import AdminDealers from "./containers/AdminDealers";
import AdminClients from "./containers/AdminClients";
import AdminAddReseller from "./containers/AdminAddReseller";
import AdminAddDealer from "./containers/AdminAddDealer";
import AdminAddClient from "./containers/AdminAddClient";
import AdminUpdateClient from "./containers/AdminUpdateClient";
import AdminUpdateReseller from "./containers/AdminUpdateReseller";
import AdminUpdateDealer from "./containers/AdminUpdateDealer";
import UpdateReseller from "./containers/UpdateReseller";
import SuperResellers from "./containers/SuperResellers";
import AddSuperReseller from "./containers/AddSuperReseller";
import UpdateSuperReseller from "./containers/UpdateSuperReseller";
import SuperResellerDealers from "./containers/SuperResellerDealers";
import SuperResellerAddDealer from "./containers/SuperResellerAddDealer";
import SuperResellerUpdateDealer from "./containers/SuperResellerUpdateDealer";
import SuperResellerClients from "./containers/SuperResellerClients";
import SuperResellerAddClient from "./containers/SuperResellerAddClient";
import SuperResellerUpdateClient from "./containers/SuperResellerUpdateClient";
import AdminMessage from "./containers/AdminMessage";
import ResellerDashboard from "./containers/ResellerDashboard";
import ResellerClients from "./containers/ResellerClients";
import ResellerAddClient from "./containers/ResellerAddClient";
import ResellerUpdateClient from "./containers/ResellerUpdateClient";
import SuperResellerDashboard from "./containers/SuperResellerDashboard";
import Dealers from "./containers/Dealers";
import AddDealer from "./containers/AddDealer";
import UpdateDealer from "./containers/UpdateDealer";
import DealerTransactions from './containers/DealerTransactions';
import DealerMacCheck from './containers/DealerMacCheck';
import ResellerMacCheck from './containers/ResellerMacCheck';
import SuperResellerMacCheck from './containers/SuperResellerMacCheck';
import DealerMessage from './containers/DealerMessage';
import ResellerMessage from './containers/ResellerMessage';
import SuperResellerMessage from './containers/SuperResellerMessage';
import AdminClientMessage from './containers/AdminClientMessage';
import ResellerTransactions from './containers/ResellerTransactions';
import SuperResellerTransactions from './containers/SuperResellerTransactions';
import AdminTransactions from './containers/AdminTransactions';
import AdminMac from './containers/AdminMac';
import DealerTickets from './containers/DealerTickets';
import AdminTickets from './containers/AdminTickets';
import DealerAddTicket from './containers/DealerAddTicket';
import UpdateTicket from './containers/UpdateTicket';
import AdminUpdateTicket from './containers/AdminUpdateTicket';
import ResellerTickets from './containers/ResellerTickets';
import ResellerAddTicket from './containers/ResellerAddTicket';
import ResellerUpdateTicket from './containers/ResellerUpdateTicket';
import SuperResellerTickets from './containers/SuperResellerTickets';
import SuperResellerUpdateTicket from './containers/SuperResellerUpdateTicket';
import SuperResellerAddTicket from './containers/SuperResellerAddTicket';

function Routes(props) {
    let routes = (
        <Switch>
            <Route path="/login" exact component={Login} />
            <Redirect to="/login" />
        </Switch>
    );

    if (props.isAuthenticated && props.role==='dealer'){
        routes = (
            <Switch>
                <Route path="/" exact component={Dashboard} />
                <Route path="/clients" exact component={Clients} />
                <Route path="/addclient" exact component={AddClient} />
                <Route path="/updateclient" exact component={UpdateClient} />
                <Route path="/transactions" exact component={DealerTransactions} />
                <Route path="/checkmac" exact component={DealerMacCheck} />
                <Route path="/dmessage" exact component={DealerMessage} />
                <Route path="/dsupport" exact component={DealerTickets} />
                <Route path="/addticket" exact component={DealerAddTicket} />
                <Route path="/updateticket" exact component={UpdateTicket} />
                <Route path="/logout" component={Logout} />
                <Redirect to="/" />
                <Route component={NotFound} />
            </Switch>
        );
    }

    if (props.isAuthenticated && props.role==='reseller'){
        routes = (
            <Switch>
                <Route path="/" exact component={ResellerDashboard} />
                <Route path="/dealers" exact component={Dealers} />
                <Route path="/adddealer" exact component={AddDealer} />
                <Route path="/updatedealer" exact component={UpdateDealer} />
                <Route path="/resellerclients" exact component={ResellerClients} />
                <Route path="/reselleraddclient" exact component={ResellerAddClient} />
                <Route path="/resellerupdateclient" exact component={ResellerUpdateClient} />
                <Route path="/transactions" exact component={ResellerTransactions} />
                <Route path="/checkmac" exact component={ResellerMacCheck} />
                <Route path="/rmessage" exact component={ResellerMessage} />
                <Route path="/rsupport" exact component={ResellerTickets} />
                <Route path="/addticket" exact component={ResellerAddTicket} />
                <Route path="/updateticket" exact component={ResellerUpdateTicket} />
                <Route path="/logout" component={Logout} />
                <Redirect to="/" />
                <Route component={NotFound} />
            </Switch>
        );
    }

    if (props.isAuthenticated && props.role==='superreseller'){
        routes = (
            <Switch>
                <Route path="/" exact component={SuperResellerDashboard} />
                <Route path="/resellers" exact component={Resellers} />
                <Route path="/addreseller" exact component={AddReseller} />
                <Route path="/updatereseller" exact component={UpdateReseller} />
                <Route path="/managerdealers" exact component={SuperResellerDealers} />
                <Route path="/manageradddealer" exact component={SuperResellerAddDealer} />
                <Route path="/managerupdatedealer" exact component={SuperResellerUpdateDealer} />
                <Route path="/managerclients" exact component={SuperResellerClients} />
                <Route path="/manageraddclient" exact component={SuperResellerAddClient} />
                <Route path="/managerupdateclient" exact component={SuperResellerUpdateClient} />
                <Route path="/transactions" exact component={SuperResellerTransactions} />
                <Route path="/checkmac" exact component={SuperResellerMacCheck} />
                <Route path="/smessage" exact component={SuperResellerMessage} />
                <Route path="/ssupport" exact component={SuperResellerTickets} />
                <Route path="/addticket" exact component={SuperResellerAddTicket} />
                <Route path="/updateticket" exact component={SuperResellerUpdateTicket} />
                <Route path="/logout" component={Logout} />
                <Redirect to="/" />
                <Route component={NotFound} />
            </Switch>
        );
    }

    if (props.isAuthenticated && props.role==='admin'){
        routes = (
            <Switch>
                <Route path="/" exact component={AdminDashboard} />
                <Route path="/superresellers" exact component={SuperResellers} />
                <Route path="/addsuperreseller" exact component={AddSuperReseller} />
                <Route path="/adminaddreseller" exact component={AdminAddReseller} />
                <Route path="/adminadddealer" exact component={AdminAddDealer} />
                <Route path="/adminupdatereseller" exact component={AdminUpdateReseller} />
                <Route path="/adminupdatedealer" exact component={AdminUpdateDealer} />
                <Route path="/manageresellers" exact component={AdminResellers} />
                <Route path="/managedealers" exact component={AdminDealers} />
                <Route path="/manageclients" exact component={AdminClients} />
                <Route path="/adminaddclient" exact component={AdminAddClient} />
                <Route path="/adminupdateclient" exact component={AdminUpdateClient} />
                <Route path="/updatesuperreseller" exact component={UpdateSuperReseller} />
                <Route path="/message" exact component={AdminMessage} />
                <Route path="/deletemac" exact component={AdminMac} />
                <Route path="/transactions" exact component={AdminTransactions} />
                <Route path="/amessage" exact component={AdminClientMessage} />
                <Route path="/asupport" exact component={AdminTickets} />
                <Route path="/updateticket" exact component={AdminUpdateTicket} />
                <Route path="/logout" component={Logout} />
                <Redirect to="/" />
                <Route component={NotFound} />
            </Switch>
        );
    }

    return (
        <>
            {routes}
        </>
    );
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        role: state.auth.role
    }
};

export default connect(mapStateToProps, null)(Routes);